import React from 'react'
import { enqueueSnackbar, BaseVariant, closeSnackbar } from 'notistack'
import { IconButton } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

/**
 * Specially useful for request status updates (success, error, etc)
 */
export default function showSnackbar(text: string, variant: BaseVariant = 'success', ttl = 5000): void {
  enqueueSnackbar(text, {
    variant,
    autoHideDuration: ttl,
    preventDuplicate: true,
    hideIconVariant: false,
    action: snackbarId => (
      <IconButton onClick={() => closeSnackbar(snackbarId)}>
        <CloseIcon fontSize="small" sx={{ color: 'var(--white)' }} />
      </IconButton>
    )
  })
}
